/**
 * Replace these with your OpenTok API key, a session ID for a routed OpenTok session,
 * and a token that has the publish role:
 */
const MinediaNetworkCalculator = function (progressCallback, finishCallback) {
  const TEST_TIMEOUT_MS = 15000; // 15 seconds
  const WINDOW_SIZE = 2000;

  const testStreamingCapability = function (subscriber) {
    performQualityTest({ subscriber, timeout: TEST_TIMEOUT_MS }, (error, lastStats, results) => {
      if (lastStats.video) {
        const video = [];
        const audio = [];

        results.forEach((result) => {
          video.push(result.video);
          audio.push(result.audio);
        });
        finishCallback && finishCallback({ audio, video });
      }
    });
  };

  // Helpers
  function pluck(arr, propertName) {
    return arr.map((value) => value[propertName]);
  }

  function sum(arr, propertyName) {
    if (typeof propertyName !== 'undefined') {
      arr = pluck(arr, propertyName);
    }

    return arr.reduce((previous, current) => previous + current, 0);
  }

  function max(arr) {
    return Math.max.apply(undefined, arr);
  }

  function min(arr) {
    return Math.min.apply(undefined, arr);
  }

  function calculatePerSecondStats(statsBuffer, seconds) {
    const stats = {};
    const activeMediaTypes = Object.keys(statsBuffer[0] || {}).filter((key) => key !== 'timestamp');

    activeMediaTypes.forEach((type) => {
      const packetsPerSecond = sum(pluck(statsBuffer, type), 'packetsReceived') / seconds;
      const packetsLostPerSecond = sum(pluck(statsBuffer, type), 'packetsLost') / seconds;
      stats[type] = {
        bitrate: sum(pluck(statsBuffer, type), 'bytesReceived') * 8 / seconds,
        packets_loss_ratio: packetsLostPerSecond / packetsPerSecond * 100,
      };
    });

    stats.windowSize = seconds;
    return stats;
  }

  function getSampleWindowSize(samples) {
    const times = pluck(samples, 'timestamp');
    return (max(times) - min(times)) / 1000;
  }

  if (!Array.prototype.forEach) {
    Array.prototype.forEach = function (fn, scope) {
      for (let i = 0, len = this.length; i < len; ++i) {
        fn.call(scope, this[i], i, this);
      }
    };
  }

  function bandwidthCalculatorObj(config) {
    let intervalId;

    config.pollingInterval = config.pollingInterval || 500;
    config.windowSize = WINDOW_SIZE;
    config.subscriber = config.subscriber || undefined;

    return {
      start(reportFunction) {
        let statsBuffer = [];
        const last = {
          audio: {},
          video: {},
        };

        intervalId = window.setInterval(() => {
          if (!config.subscriber) {
            return;
          }
          config.subscriber.getStats((error, stats) => {
            const activeMediaTypes = Object.keys(stats).filter((key) => key !== 'timestamp');
            const snapshot = {};
            const nowMs = new Date().getTime();
            let sampleWindowSize;

            activeMediaTypes.forEach((type) => {
              snapshot[type] = Object.keys(stats[type]).reduce((result, key) => {
                result[key] = stats[type][key] - (last[type][key] || 0);
                last[type][key] = stats[type][key];
                return result;
              }, {});
            });

            // get a snapshot of now, and keep the last values for next round
            snapshot.timestamp = stats.timestamp;

            statsBuffer.push(snapshot);
            statsBuffer = statsBuffer.filter(
              (value) => nowMs - value.timestamp < config.windowSize,
            );

            sampleWindowSize = getSampleWindowSize(statsBuffer);

            if (sampleWindowSize !== 0) {
              reportFunction(
                calculatePerSecondStats(
                  statsBuffer,
                  sampleWindowSize + config.pollingInterval / 1000,
                ),
              );
            }
          });
        }, config.pollingInterval);
      },

      stop() {
        window.clearInterval(intervalId);
      },
    };
  }

  function performQualityTest(config, callback) {
    const startMs = new Date().getTime();
    let testTimeout;
    let currentStats;
    const statsStuck = [];

    const bandwidthCalculator = bandwidthCalculatorObj({
      subscriber: config.subscriber,
    });

    const cleanupAndReport = function () {
      currentStats.elapsedTimeMs = new Date().getTime() - startMs;
      callback(undefined, currentStats, statsStuck);

      window.clearTimeout(testTimeout);
      bandwidthCalculator.stop();

      callback = function () {};
    };

    // bail out of the test after 30 seconds
    window.setTimeout(cleanupAndReport, config.timeout);

    bandwidthCalculator.start((stats) => {
      currentStats = stats;
      statsStuck.push(stats);

      const processedPercents = (new Date().getTime() - startMs) / TEST_TIMEOUT_MS * 100;
      const remainingSeconds = Math.floor(
        (TEST_TIMEOUT_MS - (new Date().getTime() - startMs)) / 1000,
      );

      progressCallback && progressCallback(processedPercents, remainingSeconds);
    });
  }

  return (subscriber) => testStreamingCapability(subscriber);
};

export default MinediaNetworkCalculator;
